var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align-content":"start","dense":"","no-gutters":""}},[_c('v-chip-group',{attrs:{"dense":""}},_vm._l((_vm.subColors),function(color){return _c('v-chip',{key:color.id,attrs:{"color":color,"label":""}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }